import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "dialog",
    "title",
    "subtitle",
    "titleSource",
    "subTitleSource",
    "content",
    "footer",
    "footerSource",
    "footerItem",
    "form",
  ]

  open(e) {
    e.preventDefault()
    const link = e.currentTarget
    this.dialogTarget.showModal()
    this.loadingIndicator = this.contentTarget.innerHTML
    this.contentTarget.src = link.getAttribute("href")
    document.activeElement?.blur()
  }

  safeClose(e) {
    if (this.contentTarget.contains(e.target)) return
    this.close()
  }

  close() {
    this.dialogTarget.close()
    this.resetContent()
  }

  titleSourceTargetConnected(e) {
    const title = e.getAttribute("title")
    this.setTitle(title)
  }

  subTitleSourceTargetConnected(e) {
    const subtitle = e.innerHTML
    this.setSubtitle(subtitle)
  }

  footerSourceTargetConnected() {
    this.resetFooter()
    this.footerItemTargets.forEach((item) => {
      this.footerTarget.appendChild(item)
    })
  }

  resetContent() {
    this.contentTarget.innerHTML = this.loadingIndicator
    this.setTitle("")
    this.setSubtitle("")
    this.resetFooter()
  }

  setTitle(value) {
    this.titleTarget.textContent = value
  }

  setSubtitle(value) {
    this.subtitleTarget.innerHTML = value
  }

  resetFooter() {
    this.footerTarget.innerHTML = ""
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  toggleSubmit(enabled) {
    const buttons = this.footerTarget.children

    for (let button of buttons) {
      if (enabled) {
        button.classList.remove("cursor-not-allowed")
        button.disabled = false
      } else {
        button.classList.add("cursor-not-allowed")
        button.disabled = true
      }
    }
  }
}
